import { Pipe, PipeTransform } from '@angular/core';

export interface FlatGroupItem {
  header?: string;
  data?: any[];
  report?: any;
  groupChild?: boolean;
}

@Pipe({
  name: 'flattenGroups',
})
export class FlattenGroupsPipe implements PipeTransform {
  // Virtual scroll needs near-uniform item heights: emit the group header and each
  // report as separate flat items instead of one variable-height item per patient.
  transform(groups: Array<{ groupName: string; data: any }>): FlatGroupItem[] {
    if (!groups) {
      return groups as any;
    }
    const items: FlatGroupItem[] = [];
    for (const group of groups) {
      if (group.groupName && group.data) {
        items.push({ header: group.groupName, data: group.data });
        for (const report of group.data) {
          items.push({ report, groupChild: true });
        }
      } else {
        items.push({ report: group.data, groupChild: false });
      }
    }
    return items;
  }
}
